<template>
<div id="gifts-detail">
    <!-- 我的礼包 -->
    <div class="header">
        <div class="img-box">
            <img src="@/static/images/home/pic_list.png" />
        </div>
        <div class="info">
            <div class="title">
                <span class="tip1">{{ detail.brand }}</span> {{ detail.name }}
            </div>
            <p>有效期至：{{ detail.period }}</p>
            <p class="price">
                <span v-if="detail.amount>0">面值：{{ detail.amount||'' }}元</span>
                <!-- <span>兑换比例：{{ detail.ratio }}%</span> -->
            </p>
        </div>
    </div>
    <div class="form">
        <p class="tip">
            如卡券不能正常使用，请在个人中心点击头像，<br />
            完善姓名及车牌号信息，稍等片刻即可。
        </p>
    </div>
    <!-- 礼包详情 -->
    <div style="height:300px;" v-if="detail.cardList.length == 0 && !isSubmit"></div>
    <div class="result" v-if="detail.cardList.length != 0">
        <table border="1">
            <tr class="head">
                <td width="120px">卡券名称</td>
                <td width="100px">卡券面值（元）</td>
                <td width="50px">张数</td>
                <td width="50px">操作</td>
            </tr>
            <tr v-for="(item, index) in detail.cardList" :key="index">
                <td>{{ item.name }}</td>
                <td>{{ item.amount }}</td>
                <td>1</td>
                <td @click="type(item, 1)">
                    <span class="green" v-html="type(item, 0)"></span>
                </td>
            </tr>
            <!-- <tr>
          <td>汽车检测服务卡</td>
          <td>200</td>
          <td>45</td>
          <td class="green">去使用</td>
        </tr>
        <tr>
          <td>车身防锈检测</td>
          <td>200</td>
          <td>45</td>
          <td class="green">去使用</td>
        </tr> -->
        </table>
    </div>
    <!-- 转让 -->
    <div v-if="isSubmit == 1">
        <mt-button size="large" type="primary" @click="transfer">转让</mt-button>
    </div>
    <!-- 提交表单 -->
    <div class="form" v-if="isSubmit == 2">
        <ul>
            <li>
                <span>姓名：</span>
                <input type="text" placeholder="请输入姓名" v-model="receivePerson" />
            </li>
            <li>
                <span>身份证号：</span>
                <input type="text" placeholder="请输入身份证号" v-model="idCard" />
            </li>
            <li>
                <span>银行卡号：</span>
                <input type="number" placeholder="请输入银行卡号" v-model="receiveAccount" />
            </li>
            <li>
                <span>开户行：</span>
                <input type="text" placeholder="请输入开户行" v-model="receiveBank" />
            </li>
            <li>
                <span>银行预留手机号：</span>
                <input type="text" placeholder="银行预留手机号" v-model="bankMobile" />
            </li>
            <li class="upload">
                <span>身份证正反面：</span>
                <div class="img-box">
                    <div class="img">
                        <label for="up" v-if="idcardFront == ''">
                            <img src="@/static/images/other/up.png" class="icon" />
                            <p>正面（拍照）</p>
                        </label>
                        <img :src="host + idcardFrontPath" alt="正面（拍照）" v-if="idcardFront != ''" class="show-img" />
                    </div>
                    <div class="img">
                        <label for="down" v-if="idcardReverse == ''">
                            <img src="@/static/images/other/up.png" class="icon" />
                            <p>反面（拍照）</p>
                        </label>
                        <img :src="host + idcardReversePath" alt="反面（拍照）" v-if="idcardReverse != ''" class="show-img" />
                    </div>
                </div>
            </li>
        </ul>
        <mt-button size="large" type="primary" @click="submit">提交</mt-button>
        <p class="tip">
            请输入您的银行卡信息并检查无误，<br />
            转让完成后转让金额直接汇入当前卡号。
        </p>
    </div>

    <input type="file" accept="image/*" id="up" @change="onFileChange('up')" ref="up" />
    <input type="file" accept="image/*" id="down" @change="onFileChange('down')" ref="down" />
</div>
</template>

<script>
import {
    mapState
} from "vuex";
import {
    apis
} from "@/static/js/apis.js";
import axios from "axios";
export default {
    data() {
        return {
            isSubmit: 0, //1转让 2提交 0不转不提
            ticketId: "",
            detail: {
                cardList: [],
            },
            receivePerson: "", //    收款人
            receiveAccount: "", //      收款账户
            receiveBank: "", //  开户行
            idCard: "", //身份证号
            bankMobile: "", //银行预留手机号
            idcardFront: "", //身份证正面照
            idcardReverse: "", //身份证反面照
            idcardFrontPath: "", //身份证正面照Path
            idcardReversePath: "", //身份证反面照Path
        };
    },
    mounted() {
        this.ticketId = this.$route.params.id;
        this.queryTicketDetail();
        console.log(apis);
    },
    methods: {
        //查询我的礼包详情接口
        queryTicketDetail() {
            this.post(this.apis.queryTicketDetail, {
                    memberId: this.userInfo.memberId,
                    ticketId: this.ticketId,
                })
                .then((response) => {
                    if (response.data.retCode == "SUCCESS") {
                        this.detail = response.data;
                        //校验是否可转让
                        if (
                            response.data.isExpire == 0 &&
                            response.data.transferStatus == 0 &&
                            response.data.amount > 0
                        ) {
                            this.isSubmit = 1;
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        transfer() {
            this.isSubmit = 2;
        },
        submit() {
            if (this.receivePerson == "") {
                this.$toast({
                    message: "请输入姓名",
                    duration: 900,
                });
                return;
            }
            if (this.idCard == "") {
                this.$toast({
                    message: "请输入身份证号",
                    duration: 900,
                });
                return;
            }
            if (this.receiveAccount == "") {
                this.$toast({
                    message: "请输入银行卡号",
                    duration: 900,
                });
                return;
            }
            if (this.receiveBank == "") {
                this.$toast({
                    message: "请输入开户行",
                    duration: 900,
                });
                return;
            }
            if (this.idCard.length >= 20) {
                this.$toast({
                    message: "身份证号不正确",
                    duration: 900,
                });
                return;
            }
            if (this.bankMobile == "") {
                this.$toast({
                    message: "请输入银行预留手机号",
                    duration: 900,
                });
                return;
            }
            if (this.idcardFront == "") {
                this.$toast({
                    message: "请上传身份证正面",
                    duration: 900,
                });
                return;
            }
            if (this.idcardReverse == "") {
                this.$toast({
                    message: "请上传身份证反面",
                    duration: 900,
                });
                return;
            }
            this.post(this.apis.transferApplication, {
                    memberId: this.userInfo.memberId,
                    memberTicketId: this.ticketId,
                    receivePerson: this.receivePerson,
                    receiveAccount: this.receiveAccount,
                    receiveBank: this.receiveBank,
                    idCard: this.idCard,
                    bankMobile: this.bankMobile, //银行预留手机号
                    idcardFront: this.idcardFront, //身份证正面照
                    idcardReverse: this.idcardReverse, //身份证反面照
                    sourceType: "0",
                })
                .then((response) => {
                    this.$toast({
                        message: response.data.retMsg,
                        duration: 1000,
                    });
                    if (response.data.retCode == "SUCCESS") {
                        setTimeout(() => {
                            this.$router.push({
                                name: "OrderList",
                                params: {
                                    id: 2
                                }
                            });
                        }, 800);
                        this.isSubmit = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        /*     type(item) {
          let ret = "";
          if (item.transferType == 1) {
            ret = "-";
          } else {
            if (item.useStatus == 1) {
              ret = "已使用";
            } else {
              ret = "去使用";
            }
          }
          return ret;
        }, */
        type(item, click) {
            let ret = "-";
            if (
                item.isExpire == 0 &&
                item.cardType == 0 &&
                item.interfaceCallStatus == 1 &&
                (item.useStatus == 0 || item.useStatus == 2 || item.useStatus == 5)
            ) {
                ret = "使用";
                if (click == 1) {
                    this.post(this.apis.toUseCard, {
                            cardId: item.id,
                        })
                        .then((response) => {
                            if (response.data.retCode == "SUCCESS") {
                                // this.detail = response.data;
                                window.location.href = response.data.url;
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            } else if (item.isExpire == 0 && item.cardType == 1) {
                ret = "使用";
                //请持当前卡券去线下服务点使用
                if (click == 1) {
                    this.$toast({
                        message: "请持当前卡券去线下服务点使用",
                        duration: 1800,
                    });
                }
            } else if (
                item.isExpire == 0 &&
                item.cardType == 0 &&
                item.interfaceCallStatus == 1 &&
                (item.useStatus == 1 ||
                    item.useStatus == 3 ||
                    item.useStatus == 4 ||
                    item.useStatus == 6 ||
                    item.useStatus == 7)
            ) {
                ret = "查看";
                if (click == 1) {
                    this.post(this.apis.toShowCard, {
                            cardId: item.id,
                        })
                        .then((response) => {
                            if (response.data.retCode == "SUCCESS") {
                                // this.detail = response.data;
                                window.location.href = response.data.url;
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            }
            if (click == 0) {
                return ret;
            }
        },
        onFileChange(p) {
            // idcardFront: "", //身份证正面照
            // idcardReverse: "", //身份证反面照
            // idcardFrontPath: "", //身份证正面照Path
            // idcardReversePath: "", //身份证反面照Path

            if (p == "up") {
                //正面
                let file = this.$refs.up.files[0];
                console.log("onFileChange -> file", file);

                //文件小于5M
                let fileMaxSize = 5120; //5M
                let fileSize = file.size;
                let size = fileSize / 1024; //1M = 1024
                if (size > fileMaxSize) {
                    this.$refs.up.value = "";
                    this.$toast({
                        message: "文件大小不能大于5M！",
                        duration: 1800,
                    });
                    return false;
                }

                //请求 二进制流
                let formData = new FormData();
                formData.append("file", file);
                axios({
                    url: apis.webUpload,
                    method: "POST",
                    data: formData,
                    timeout: 0, //无超时
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }).then((res) => {
                    this.idcardFront = res.data.id;
                    this.idcardFrontPath = res.data.filePath;
                });
            } else {
                //反面
                let file = this.$refs.down.files[0];
                let formData = new FormData();
                formData.append("file", file);
                axios({
                    url: apis.webUpload,
                    method: "POST",
                    data: formData,
                    timeout: 0, //无超时
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }).then((res) => {
                    this.idcardReverse = res.data.id;
                    this.idcardReversePath = res.data.filePath;
                });
            }
        },
    },
    computed: {
        ...mapState(["userInfo"]),
    },
};
</script>

<style lang="less" scoped>
#gifts-detail {
    padding: 41px 50px 0;

    .header {
        display: flex;

        .img-box {
            width: 140px;
            height: 140px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 30px;

            img {
                max-width: 100%;
                max-height: 100%;
            }
        }

        .info {
            .title {
                font-family: PingFang-SC-Bold;
                font-weight: bold;
                color: #3a3a3a;
                font-size: 30px;
                width: 440px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                .tip1 {
                    display: inline-block;
                    padding: 0 10px;
                    margin-right: 10px;
                    background-color: #1fbe6e;
                    border-radius: 4px;
                    font-family: PingFang-SC-Regular;
                    font-size: 24px;
                    line-height: 42px;
                    color: #fff;
                    text-align: center;
                }
            }

            p {
                &.price {
                    display: flex;
                    justify-content: space-between;
                }

                padding-top: 20px;
                font-family: PingFang-SC-Regular;
                color: #3a3a3a;
            }
        }

        padding-bottom: 30px;
    }

    .result {
        // padding-top: 68px;
        padding-bottom: 73px;

        table {
            margin: 0 auto;
            width: 626px;
            height: 203px;
            background-color: #ffffff;
            border: solid 1px #1fbe6e;
            text-align: center;

            .head {
                font-family: PingFang-SC-Medium;
                font-size: 24px;
                color: #067e42;
            }

            td {
                height: 66px;
            }
        }

        .code {
            font-family: PingFang-SC-Bold;
            font-size: 34px;
            font-weight: bold;
            text-align: center;
        }
    }

    .form {
        ul {
            padding-bottom: 73px;

            li {
                display: flex;
                height: 80px;
                align-items: center;

                span {
                    flex: 0 0 250px;
                    font-family: PingFang-SC-Regular;
                    font-size: 28px;
                    color: #292929;
                    text-align: right;
                }

                &.upload {
                    height: 360px;
                    align-items: start;

                    .img-box {
                        padding-top: 10px;
                        display: flex;
                        flex-direction: column;

                        .img {
                            width: 244px;
                            height: 161px;
                            background-color: #f4f4f4;
                            border-radius: 10px;
                            border: solid 1px #c5c5c5;
                            margin-bottom: 40px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            font-family: PingFang-SC-Regular;
                            font-size: 24px;
                            line-height: 40px;
                            color: #9a9a9a;

                            .icon {
                                width: 46px;
                                height: 44px;
                            }
                        }

                        .show-img {
                            width: 244px;
                            height: 161px;
                            border-radius: 10px;
                            border: solid 1px #c5c5c5;
                        }

                        label {
                            text-align: center;
                        }
                    }
                }

                input {
                    flex: 1;
                    border: none;
                    outline: none;
                    border-bottom: 1px solid #c5c5c5;
                }
            }
        }
    }

    .tip {
        padding-top: 40px;
        padding-left: 20px;
        padding-bottom: 40px;
        height: 60px;
        font-family: PingFang-SC-Medium;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 37px;
        letter-spacing: 0px;
        color: #575757;
    }

    #up,
    #down {
        width: 0;
        height: 0;
    }
}
</style>
